import * as RadixSlider from '@radix-ui/react-slider';
import styles from './Slider.module.scss';

type SliderProps = {
  value: number[];
  onValueChange: (value: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
};

export const Slider = ({ value, onValueChange, disabled, max, min, step }: SliderProps) => {
  return (
    <RadixSlider.Root
      className={styles['slider']}
      value={value}
      onValueChange={(value) => {
        onValueChange(value);
      }}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
    >
      <RadixSlider.Track className={styles['track']}>
        <RadixSlider.Range className={styles['range']} />
      </RadixSlider.Track>
      <RadixSlider.Thumb className={styles['thumb']} aria-label='SliderThumb' />
    </RadixSlider.Root>
  );
};
